import { Component, Input, ChangeDetectionStrategy, Injector } from '@angular/core'
import { Store } from '@ngrx/store'
import { NavController } from 'ionic-angular'
import { UIEventHub } from '../../../services/event.service'
import { ActionCreator } from '../../../services/action.service'
import { ViewModel } from '../../../view-model'
import { BaseWidget } from '../../base-widget'
/**
 * アラートバー
 *【内容:text:string】
 *【表示条件:visible:boolean】
 *【メッセージリスト:messageList:{id:string, message:string}[]】
 * @author nabla2.metamodel.generator
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-alert-bar',
  templateUrl: './alert-bar.html',
  styles: [`
    sg-fr-alert-bar {
      white-space:pre;
      height:auto;
      line-height: 2.0;
      margin-left: 10px;
    }
  `]
})
export class AlertBar extends BaseWidget {
  /**
   * 内容
   */
  @Input() text:string

  /**
   * 表示条件
   */
  @Input() visible:boolean

  /**
   * メッセージリスト
   */
  @Input() messageList:{id:string, message:string}[]

  /**
   * コンストラクタ
   * @param navCtrl 画面遷移管理サービス
   * @param store Reduxストア
   */
  constructor(
    public navCtrl: NavController,
    public store: Store<{viewModel:ViewModel}>,
    public eventHub: UIEventHub,
    public actionCreator: ActionCreator,
    public injector: Injector,
  ) {
    super(injector)
  }
  showMessage():string {
    let msg = '';
    this.messageList.forEach((m) => {
      msg += m.id + ' : ' + m.message + '\n';
    });
    return msg;
  }
}


// WEBPACK FOOTER //
// ./src/widgets/alert/alert-bar/alert-bar.component.ts